import React from 'react';
import ProjectTemplate from '../components/ProjectTemplate';

const MedusaPage = () => {

  return (
    <div className="medusa-page">
      
 <ProjectTemplate
title="medusa"
year="2018"
  sections={[
    {
      type: 'description',
      text: 'Medusa is an installation that is based on the chaotic movement of a cloth in water which influences live generated tones through FM synthesis. The cloth is put in motion by 3 water pumps which sporadically turn on and off. Likewise the aquarium lighting sporadically switches from a TLC tube to an intense strobe and back. Inspired by the movement of marine life such as the jellyfish or squid, Medusa resembles a sea creature contained within an aquarium.',
    },
    {
      type: 'video',
      links: ['https://www.youtube.com/embed/xEsrlPUor6s?controls=1&modestbranding=1&rel=0&showinfo=0']
    }
  ]}
  
/>

    </div>
  );
};

export default MedusaPage;
